<template>
  <div>
    <template v-if="trx.status_id == 2">
      <template v-if="trx.gateway_id == 1">
        <div class="text-xs my-2 bg-white flex flex-col border rounded-lg">
          <div class="p-1 flex flex-col justify-between items-start">
            <label class="font-semibold">HESAP BİLGİLERİ</label>
            <span style="white-space: pre-wrap; ">{{ trx.delivery_iban }}</span>
          </div>
        </div>
      </template>
      <template v-if="trx.gateway_id == 5">
        <div class="text-xs my-2 bg-white flex flex-col border rounded-lg">
          <div class="p-1 flex flex-col justify-between items-start">
            <label class="font-semibold">CÜZDAN BİLGİLERİ</label>
            <span style="white-space: pre-wrap; ">{{ trx.delivery_iban }}</span>
          </div>
        </div>
      </template>
    </template>

    <div :key="itm.value" v-for="itm in $root.cache.getOptions[146]">
      <div class="flex flex-col items-start justify-start space-y-1">
        <template v-if="trx.status_id == itm.value">
          <template v-for="(fl, dp) in JSON.parse(itm.flow)">
            <template v-if="$root.cache.me.department == dp">
              <div
                @click="changeStatus(trx, trx.id, vl)"
                v-for="vl in fl"
                class="cursor-pointer global-button-xs"
                :key="vl"
              >
                {{ $root.getVal(146, vl) }}
              </div>
            </template>
          </template>  
          <div
          v-if="trx.type == 'ÇEKİM' && $root.cache.me.department == 'finance'" 
                @click="changeStatus(trx, trx.id, 14)" 
                class="cursor-pointer global-button-xs" 
              >
                {{ $root.getVal(146, 14) }}
              </div>

        </template>
      </div>
    </div>

    <form
      v-if="platformAmountForm"
      class="text-xs flex space-x-2 items-center"
      @submit.prevent="riskOkWithdrawal()"
    >
    <div>
        <label>Bankadan Çıkarılan Tutar </label>
        <div class="flex items-center space-x-2">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_bank"
          />

          <select
            v-model="form.bank_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <label>Platformdan Çıkarılan Tutar </label>
        <div class="flex items-center space-x-2">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_platform"
          />

          <select
            v-model="form.platform_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>
    <form
      v-if="bankAmountForm"
      class="text-xs flex space-x-2 items-center"
      @submit.prevent="finansOkWithdrawal()"
    >
      <div>
        <label>Bankadan Çıkarılan Tutar </label>
        <div class="flex items-center space-x-2">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_bank"
          />

          <select
            v-model="form.bank_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>
  </div>
</template>
<script>
import http from "../../../services/http";
import EventBus from "../../Ui/EventBus";

import SaveButton from "../../Ui/SaveButton.vue";
export default {
  props: ["trx"],
  data() {
    return {
      platformAmountForm: false,
      bankAmountForm: false,
      form: {
        platform_currency_id: 1,
        bank_currency_id: 6,
      },
    };
  },
  components: {
    SaveButton,
  },
  methods: {
    riskOkWithdrawal() {
      http.transaction
        .riskOkWithdrawal(this.trx.id, this.form)
        .then(() => {
          EventBus.$emit("transactionReload", true);
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },
    finansOkWithdrawal() {
      http.transaction
        .finansOkWithdrawal(this.trx.id, this.form)
        .then(() => {
          EventBus.$emit("transactionReload", true);
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },
    changeStatus(trx, trxId, vv) {
      if (vv == 14) {
        this.bankAmountForm = true;
      } else if (vv == 16) {
        this.platformAmountForm = true;
      } else {
        http.transaction
          .changeStatus(trxId, { status_id: vv })
          .then((resp) => {
            if (resp.data.success) {
              EventBus.$emit("transactionReload", true);
            }
          })
          .catch((msg) => {
            this.$root.errorMessage(msg.response.data);
          });
      }
    },
  },
};
</script>
